import React from 'react';
import { connect } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import mobileConfigActions from '../../../../../actions/mobileConfig.actions';
import helper from '../../../../../utils/helper';
import MobileConfigurationPresetsPage from './MobileConfigurationPresetsPage';

function MobileConfigurationPresets(props) {
  const history = useHistory();
  const deptId = JSON.parse(localStorage.getItem('userProfile')).departmentId;
  React.useEffect(() => {
    props.getMobileConfigsByDeptId(deptId);
  }, []);
  if (!helper.isMobile()) {
    return <Redirect to="/configure/mobile-configurations" />;
  }
  function onSave(mobileConfigId) {
    const result = props.saveMobileConfigId(mobileConfigId);
    if (result) {
      history.push('/');
    }
  }
  return <MobileConfigurationPresetsPage onSave={onSave} />;
}

export default connect(null, mobileConfigActions)(MobileConfigurationPresets);
